import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Notification Api Service
 */
const NotificationApiService = {

  getData: async () => {
    try {
      let url = APIConstants.ENDPOINT_NOTIFICATION_SETTINGS

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          url += `?userId=${parseToJson['userId']}`
        }
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Notification Api Service: Error Caught while fetching data`, err)
    }
  },

  getWebhookList: async (accountId) => {
    try {
      let url = APIConstants.ENDPOINT_NOTIFICATION_SLACK_WEBHOOK

      if (accountId) {
        url += `?userAccountId=${accountId}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Notification Api Service: Error Caught while fetching slack webhook list`, err)
    }
  },

  saveData: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_NOTIFICATION_SETTINGS

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Notification Api Service: Error caught while saving data`, err)
    }
  },

  saveWebhook: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_NOTIFICATION_SLACK_WEBHOOK_SAVE

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Notification Api Service: Error caught while saving webhook`, err)
    }
  },

  deleteWebhook: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_NOTIFICATION_SLACK_WEBHOOK_DELETE

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Notification Api Service: Error caught while deleting webhook`, err)
    }
  },

  updateWebhook: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_NOTIFICATION_SLACK_WEBHOOK_UPDATE

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Notification Api Service: Error caught while updating webhook`, err)
    }
  },
}

export default NotificationApiService;
